import React, { useState } from "react";
import MsHome from "../../Components/Maruti-Suzuki-components/MsHome";
import BannerImage from "../../Components/login-components/banner-image/BannerImage";
import LogoContainer from "../../Components/login-components/logo-container/LogoContainer";
import BottomCard from "../../Components/login-components/bottom-card/BottomCard";
import CommonDropDown from "../../Components/global-components/CommonDropDown/CommonDropDown";
import TextInput from "../../Components/global-components/CommonTextInput/TextInput";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Button, IconButton, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import CommonButton from "../../Components/global-components/CommonButton/CommonButton";
import { useLocation, useNavigate } from "react-router-dom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { showGlobalError } from "../Redux/globalErrorSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { customerData } from "../Redux/userData";
import { FaFilePdf, FaFileUpload, FaTimes } from 'react-icons/fa'
import { useRef } from "react";
import { eddUploadDocument } from "../../services/edd-file-upload-service";
import { scrollIntoViewFunc } from "../../Router";
import CommonTemplate, { CommonTemplate4 } from "../../Components/global-components/CommonModal";
import { AddCircleOutlineTwoTone } from "@mui/icons-material";
import { updateIsRecordExist, kycName as KycNameRedux, kycRefId as kycRefIdRedux } from "../Redux/kycDetailsSlice";

const Individual = () => {
    const { state } = useLocation();
    const { modal } = state || {};
    // const kycTypeTab = useSelector((state) => state.Tabs.kycTypeTab);
    // const kycTypeTab = "Corporate";
    const Is_IDV3 = useSelector((state) => state.kycDetails.Is_IDV3);
    const kycRefId = useSelector((state) => state.kycDetails.kycRefId);
    const kycName = useSelector((state) => state.kycDetails.kycName);
    const kycId = useSelector((state) => state.kycDetails.kycRefIdAddNewKyc);
    // let { annualIncome,occupation,organization,citizenship,nationality,political } = useSelector((state) => state.userDetails.customerData);
    let CDDData = useSelector((state) => state.userDetails.customerData);
    // console.log("eddd",{ annualIncome,occupation,organization,citizenship,nationality,political })
    // const name = useSelector((state) => state.kycDetails.KycName);
    const digitalFormSixtyID = useSelector((state) => state.digitalFormSixty.formSixtyData.digitalForm60Id);
    const { dob: dobOVD, fatherName: fatherNameOVD } = useSelector(
        (state) => state.uploadedFile.previewDocumentDetail
    );
    const userPanNumber = useSelector((state) => state.panDetails.userPanNumber);
    const { mi_u, channelUrl, subChannel } = useSelector(
        (state) => state.partnerChannelNameSlice.marutiUserDetails
    );
    const isRecordExist = useSelector((state) => state.kycDetails.isRecordExist);
    const [txnDupeError, setTxnDupeError] = useState(false)
    let {
        gender,
        maritalStatus,
        mothersName,
        fatherName,
        correspondenceAddress,
        correspondenceState,
        correspondenceCity,
        correspondencePincode,
        userEditedName,
        userEditedAddress,
        permanentAddress,
        permanentCity,
        permanentDistrict,
        permanentCountry,
        permanentState,
        permanentPincode,
        name,
        manualKYC,
        dob,
    } = useSelector((state) => state.userDetails.customerData);
    const [idvModal, setIDVModal] = useState(modal || false)
    // cdd Fields
    const [annualIncome, setAnnaulIncome] = useState(CDDData.annualIncome);
    const [citizenship, setCitizenship] = useState(CDDData.citizenship);
    const [nationality, setNationality] = useState(CDDData.nationality);
    const [nationalityOther, setNationalityOther] = useState("");
    const [political, setPolitical] = useState(CDDData.political ? "Yes" : "No");
    const [occupation, setOccupation] = useState(CDDData.occupation);
    const [occupationOther, setOccupationOther] = useState("");
    const [organization, setOrganization] = useState(CDDData.organization);
    const [organizationOther, setOrganizationOther] = useState("");
    const [error, setError] = useState("");
    // EDD Fields
    const [criminalProceedings, setCriminalProceedings] = useState("no");
    const [isHighNetworthIndividual, setIsHighNetworthIndividual] = useState(true);
    const [sourceOfFund, setSourceOfFund] = useState("");
    const [publicInfo, setPublicInfo] = useState("");
    const [purposeNatureBusinessConnection, setPurposeNatureBusinessConnection] =
        useState("");
    // File upload
    // const [incomeProof, setIncomeProof] = useState([]); // useState for PDF url
    // const [incomeProofUrl, setIncomeProofUrl] = useState([]); // useState for PDF url
    // const fileInputRef = useRef([])

    const inputRefs = useRef([]);
    const [fileNames, setFileNames] = useState([""]);
    const [uploadedUrls, setUploadedUrls] = useState([""]);
    const [allUrls, setAllUrls] = useState([])
    const [fileUploadSuccess, setFileUploadSuccess] = useState(false)



    const navigate = useNavigate();
    const dispatch = useDispatch();

    const options = {
        option1: [
            "Select",
            "0-2.5 lacs",
            "2.5-5 lacs",
            "5-15 lacs",
            "15-20 lacs",
            "20-30 lacs",
            "30+ lacs",
        ],
        option2: [
            "Select",
            "Salaried",
            "Professional",
            "Self Employeed",
            "Student",
            "Home maker",
            "Other",
        ],
        option3: [
            "Select",
            "Government",
            "Private Limited",
            "Public Limited",
            "Trust",
            "Other",
        ],
        organisationType: [
            "Select",
            "Government",
            "Private Limited",
            "Public Limited",
            "Proprietor",
            "Partnership",
            "Trust",
            "HUF",
            "Section 25 Company",
            "Other"
        ],
        option4: ["Select", "Yes", "No", "Related to one"],
        proposerType: ["Select", "I", "C"],
        companyType: ["Select", "Private", "Public", "LLP", "Other"],
        categoryBusiness: ["Select", "Insurance", "Payments", "Lending"],
        citizenshipOption: ["Select", "Resident", "Non-Resident"],
        nationalityOption: ["Select", "Indian", "Other"],
        productTypesOption: ["Select", "Personal Loan", "Business Loan"]
    };

    const handleFileUpload = async (index, e) => {
        const file = e.target.files[0];

        if (inputRefs.current[index]) {
            inputRefs.current[index].value = "";
        }

        if (!file) return;

        if (file.type !== "application/pdf") {
            return dispatch(showGlobalError("Only PDF format is allowed."));
        }

        if (file.size > 5 * 1024 * 1024) {
            return dispatch(showGlobalError("File exceeds 5MB size limit."));
        }

        if (!kycRefId && !kycId) {
            alert("Please fill all required fields.");
            return;
        }
        const formData = new FormData();
        formData.append("income_proof", file);
        formData.append("KYC_No", kycRefId || kycId);
        try {

            const response = await eddUploadDocument(formData);
            if (response?.success) {
                const uploadedUrl = response?.data?.income_proof;
                const newUrls = [...uploadedUrls];
                const newNames = [...fileNames];
                newUrls[index] = uploadedUrl;
                newNames[index] = file.name;

                setUploadedUrls(newUrls);
                setFileNames(newNames);

                setFileUploadSuccess(true)

                // alert("File uploaded successfully!");
                setTimeout(() => {
                    setFileUploadSuccess(false)
                }, 3000)
            } else {
                dispatch(showGlobalError("Upload succeeded but no file URL returned."));
            }
        } catch (error) {
            setFileUploadSuccess(false)
            console.error("Upload Error:", error);
            dispatch(showGlobalError("File upload failed."));
        }
    };

    const handleAdd = () => {
        if (uploadedUrls.length < 3) {
            setUploadedUrls([...uploadedUrls, ""]);
            setFileNames([...fileNames, ""]);
        }
    };

    const handleDelete = (index) => {
        if (uploadedUrls.length === 1) {
            const newUrls = [...uploadedUrls];
            const newNames = [...fileNames];
            newUrls[0] = "";
            newNames[0] = "";
            setUploadedUrls(newUrls);
            setFileNames(newNames);

            // reset file input
            if (inputRefs.current[0]) {
                inputRefs.current[0].value = "";
            }
        } else {
            // If there are multiple upload blocks, remove the entire block
            const newUrls = [...uploadedUrls];
            const newNames = [...fileNames];
            newUrls.splice(index, 1);
            newNames.splice(index, 1);
            setUploadedUrls(newUrls);
            setFileNames(newNames);

            // Update refs array
            inputRefs.current.splice(index, 1);
        }
        setFileUploadSuccess(false);
    };
    const removeUploadBlock = (index) => {
        const newUrls = [...uploadedUrls];
        const newNames = [...fileNames];
        newUrls.splice(index, 1);
        newNames.splice(index, 1);
        setUploadedUrls(newUrls);
        setFileNames(newNames);
    };

    const handleFinalSubmit = () => {
        const incomeFiles = {};
        uploadedUrls.forEach((url, i) => {
            if (url) incomeFiles[`income_${i + 1}`] = url;
        });
    };
    let incomeFiles = {};
    const individual_data = {
        "KYC_No": kycRefId ? kycRefId : kycId,
        "Is_IDV3": Is_IDV3,
        "Occupation": occupation === "Other"
            ? `${occupation} - ${occupationOther}`
            : occupation,
        "Organization_Type": organization === "Other"
            ? `${organization} - ${organizationOther}`
            : organization,
        "Criminal_Proceedings": criminalProceedings,
        "Source_Of_Fund": sourceOfFund,
        "Income_Proof": incomeFiles,
        "Is_High_Networth_Individual": isHighNetworthIndividual,
        "Purpose_Nature_Business_connection": purposeNatureBusinessConnection,
        "Publicly_Available_Info": publicInfo,
    }
    let old_data = JSON.stringify({
        pan: userPanNumber,
        annualIncome: annualIncome,
        occupation:
            occupation === "Other"
                ? `${occupation} - ${occupationOther}`
                : occupation,
        organizationType:
            organization === "Other"
                ? `${organization} - ${organizationOther}`
                : organization,
        citizenship: citizenship,
        nationality:
            nationality === "Other"
                ? `${nationality} - ${nationalityOther}`
                : nationality,
        isPoliticallyExposed:
            political === "Yes" || political === "Related to one" ? true : false,
        gender: gender,
        maritalStatus: maritalStatus,
        mothersName: mothersName,
        correspondenceAddress: correspondenceAddress,
        correspondenceState: correspondenceState,
        correspondenceCity: correspondenceCity,
        correspondencePincode: correspondencePincode,
        userEditedName,
        userEditedAddress,
        permanentCity,
        permanentDistrict,
        permanentCountry,
        permanentState,
        permanentPincode,
        permanentAddress,
        name,
        channel: channelUrl,
        subChannel,
        txnId: mi_u,
        kycId: kycRefId ? kycRefId : kycId,
        dob: dob || dobOVD || "",
        fatherName: fatherName || fatherNameOVD || "",
        manualKYC,
        digitalFormSixtyID: digitalFormSixtyID || "",
    });


    const onClickHandler = async () => {
        try {
            // Basic validations
            if (

                !occupation ||
                !organization ||
                (!isRecordExist && (
                    !annualIncome ||
                    !citizenship ||
                    !nationality ||
                    !political
                ))

            ) {
                setError("Please fill all mandatory fields before proceeding.");
                setTimeout(() => scrollIntoViewFunc("incomeError"), 1);
                return;
            }
            if (
                (occupation === "Other" && !occupationOther) ||
                (organization === "Other" && !organizationOther) ||
                (!isRecordExist && (
                    (nationality === "Other" && !nationalityOther)
                ))

            ) {
                setError("Please specify details for 'Other' fields");
                setTimeout(() => scrollIntoViewFunc("incomeError"), 1);
                return;
            }
            setError("")
            uploadedUrls.forEach((url, i) => {
                if (url) incomeFiles[`income_${i + 1}`] = url;
            });

            const finalData = {
                kyc_no: kycRefId,
                income_proof_url: incomeFiles,
            };

            dispatch(
                customerData({
                    // annualIncome: annualIncome,
                    // occupation: occupation === "Other" ? `${occupation} - ${occupationOther}` : occupation,
                    // organization: organization === "Other" ? `${organization} - ${organizationOther}` : organization,
                    // citizenship: citizenship,
                    // nationality: nationality === "Other" ? `${nationality} - ${nationalityOther}` : nationality,
                    // political: political === "Yes" || political === "Related to one" ? true : false,
                    criminalProceedings: criminalProceedings,
                    isHighNetworthIndividual: isHighNetworthIndividual,
                    sourceOfFund: sourceOfFund,
                    incomeProof: incomeFiles,
                    purposeNatureBusinessConnection: purposeNatureBusinessConnection,
                    publicInfo: publicInfo,
                })
            );
            // 1. First call the old PATCH KYC API
            if (!isRecordExist) {
                const configForOld = {
                    method: "patch",
                    url: `${process.env.REACT_APP_BASE_URL}/customer/customer-kyc`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: old_data,
                };
                const oldApiResponse = await axios(configForOld);
                console.log("Old KYC PATCH Success", oldApiResponse.data);
            }

            // 2. Now call the new EDD POST API
            const eddConfig = {
                method: "post",
                url: `${process.env.REACT_APP_BASE_URL}/primary/edd`,
                headers: {
                    "Content-Type": "application/json",
                },
                data: individual_data,
                params: { token: localStorage.getItem("token") },
            };
            const eddResponse = await axios(eddConfig);

            // 3. On full success, navigate to Success page
            navigate("/Success", {
                state: {
                    kyc_ref_id: eddResponse?.data?.KYC_No,
                },
            });
        } catch (error) {
            console.error("Error submitting:", error);
            if (error?.response?.data?.message === "Duplicate transaction id found") {
                setTxnDupeError(true);
            } else {
                setError("Something went wrong. Please try again.");
            }
        }
    };


    const eddHandler = () => [
        setIDVModal(false)
    ]

    const closeEddHandler = () => {
        dispatch(updateIsRecordExist(false))
        dispatch(KycNameRedux(""))
        dispatch(kycRefIdRedux(""))
        navigate("/kyc")
    }


    return (
        // fields
        // div 

        <div className="md:h-full overflow-hidden overflow-y-scroll px-2">


            {/* individualFields */}
            <>
                {/* <h1>proposer type is {kycTypeTab}</h1> */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-6 ">
                    <div className="flex flex-col">
                        <CommonDropDown
                            options={options.option2}
                            selected={occupation}
                            setSelected={setOccupation}
                            label={"Occupation"}
                            AsteriskStar={true}
                            disabled={CDDData.occupation || false}

                            // width="200px"
                            height="35px"
                        />
                        {occupation === "Other" && (
                            <TextField
                                fullWidth
                                size="small"
                                sx={{ marginTop: 1, marginBottom: 1 }}
                                placeholder="Please specify other"
                                onChange={(e) => setOccupationOther(e.target.value)}
                            />
                        )}
                    </div>
                    <div className="flex flex-col">
                        <CommonDropDown
                            options={options.organisationType}
                            selected={organization}
                            setSelected={setOrganization}
                            label={"Organization Type"}
                            AsteriskStar={true}
                            disabled={CDDData.organization || false}

                            // width="200px"
                            height="35px"
                        />
                        {organization === "Other" && (
                            <TextField
                                fullWidth
                                size="small"
                                sx={{ marginTop: 1, marginBottom: 1 }}
                                placeholder="Please specify other"
                                onChange={(e) => setOrganizationOther(e.target.value)}
                            />
                        )}
                    </div>
                    {!isRecordExist && <>
                        <div className="flex flex-col ">
                            <CommonDropDown
                                options={options?.nationalityOption}
                                selected={nationality}
                                setSelected={setNationality}
                                label={"Nationality"}
                                AsteriskStar={true}
                                disabled={CDDData.nationality || false}
                                // width="200px"
                                height="35px"
                            />

                            {nationality === "Other" && (
                                <TextField
                                    fullWidth
                                    size="small"
                                    sx={{ marginTop: 1, marginBottom: 1 }}
                                    placeholder="Please specify other"
                                    onChange={(e) => setNationalityOther(e.target.value)}
                                />
                            )}
                        </div>
                        <CommonDropDown
                            options={options?.citizenshipOption}
                            selected={citizenship}
                            setSelected={setCitizenship}
                            label={"Citizenship"}
                            AsteriskStar={true}
                            disabled={CDDData.citizenship || false}
                            // width="200px"
                            height="35px"
                        //  labelSize="small"
                        />
                        <CommonDropDown
                            options={options.option1}
                            selected={annualIncome}
                            setSelected={setAnnaulIncome}
                            label={"Annual Income"}
                            AsteriskStar={true}
                            disabled={CDDData.annualIncome || false}
                            // width="200px"
                            height="35px"
                        />
                    </>}

                    <div className="flex flex-col md:mt-1">
                        <TextInput
                            // AsteriskStar={true}
                            label="Source of Funds"
                            placeholder="Enter details"
                            id="sourceoffund"
                            value={sourceOfFund}
                            onChange={(e) => setSourceOfFund(e.target.value)}
                            height="35px"
                            labelColor="black"
                            labelStyle={{ fontSize: "14px", fontFamily: "Montserrat", fontWeight: "500" }}
                        />
                    </div>

                </div>




                <div className="w-full mt-4 md:mt-4">

                    <div className="flex justify-between items-start mb-1">

                        <div className="flex flex-col">

                            <label className="font-medium text-sm">

                                Income Proof

                            </label>

                            <div className="text-xs text-[#5A5A5A] mt-1">

                                Allowed file size is 5 MB · Supported format: PDF

                            </div>

                        </div>

                    </div>



                    {/* File attachments container */}

                    <div className="flex flex-wrap gap-3 mb-3">

                        {uploadedUrls.map((url, index) => (

                            <div

                                key={index}

                                className="w-full md:w-[calc(33.333%-0.75rem)] transition-all duration-300"

                            >

                                {url ? (

                                    // Uploaded file display

                                    <div className="border flex justify-center py-2 border-green-200 bg-green-50 rounded-lg relative h-full">

                                        <div className="flex items-center justify-center gap-2">

                                            <div className="flex-shrink-0 text-red-600">

                                                <FaFilePdf size="16" />

                                            </div>

                                            <div className="min-w-0 flex-1">

                                                <p className="text-green-800 text-sm font-medium truncate">

                                                    {fileNames[index] || `Document ${index + 1}`}

                                                </p>

                                            </div>

                                            {/* Show delete icon */}

                                            <IconButton

                                                onClick={() => handleDelete(index)}

                                                color="error"

                                                size="small"

                                                className="flex-shrink-0 hover:bg-gray-50"

                                            >

                                                <DeleteIcon fontSize="small" />

                                            </IconButton>

                                        </div>

                                    </div>

                                ) : (

                                    // Empty file input box

                                    <div

                                        className={`border-2 border-dashed rounded-lg p-2 transition-all duration-300 relative cursor-pointer border-gray-300 hover:border-gray-400`}

                                        onClick={() => inputRefs.current[index]?.click()}

                                    >

                                        {/* Show delete (cross) icon for all except first box */}

                                        {uploadedUrls.length > 1 && (

                                            <IconButton

                                                onClick={(e) => {

                                                    e.stopPropagation();

                                                    handleDelete(index);

                                                }}

                                                color="error"

                                                size="small"

                                                className="absolute -top-2 -right-2 float-right hover:bg-gray-50 z-10 bg-white"

                                            >

                                                <FaTimes size={14} />

                                            </IconButton>

                                        )}



                                        <div className="flex items-center justify-center gap-2">

                                            <div className="p-2 rounded-full bg-gray-100 text-gray-500">

                                                <FaFilePdf size={16} />

                                            </div>

                                            <div className="text-center">

                                                <p className="text-xs text-gray-500 mt-1">Click to upload</p>

                                            </div>

                                        </div>



                                        <input

                                            id={`pdf-upload-${index}`}

                                            type="file"

                                            accept="application/pdf"

                                            hidden

                                            ref={(ref) => (inputRefs.current[index] = ref)}

                                            onChange={(e) => handleFileUpload(index, e)}

                                        />

                                    </div>

                                )}

                            </div>

                        ))}



                        {/* Automatically add next empty upload field after successful upload */}

                        {uploadedUrls.filter((url) => url).length === uploadedUrls.length &&

                            uploadedUrls.length < 3 && (

                                <div className="w-full md:w-[calc(33.333%-0.75rem)]">

                                    <div

                                        className="border-2 border-dashed rounded-lg p-2 transition-all duration-300 relative cursor-pointer border-gray-300 hover:border-gray-400"

                                        onClick={() => inputRefs.current[uploadedUrls.length]?.click()}

                                    >

                                        <div className="flex items-center justify-center gap-2">

                                            <div className="p-2 rounded-full bg-gray-100 text-gray-500">

                                                <FaFilePdf size={16} />

                                            </div>

                                            <div className="text-center">

                                                <p className="text-xs text-gray-500 mt-1">Click to upload</p>

                                            </div>

                                        </div>



                                        <input

                                            id={`pdf-upload-${uploadedUrls.length}`}

                                            type="file"

                                            accept="application/pdf"

                                            hidden

                                            ref={(ref) => (inputRefs.current[uploadedUrls.length] = ref)}

                                            onChange={(e) => handleFileUpload(uploadedUrls.length, e)}

                                        />

                                    </div>

                                </div>

                            )}

                    </div>



                    {/* Success message */}

                    <div className="mt-2">

                        <p className="text-green-600 text-sm font-medium">

                            {fileUploadSuccess && "File uploaded successfully!"}

                        </p>

                    </div>

                </div>



                <div className="w-full mt-4">
                    <div className="">
                        <div className="flex flex-col md:flex-row md:items-center justify-between md:gap-2">
                            <p className="text-sm font-medium text-gray-900 md:mb-1 w-[100%]">
                                Details of criminal proceedings during the last 3 years  :
                                {/* <span className="text-red-600">*</span> */}
                            </p>
                            <RadioGroup
                                row
                                name="key_metrics1"
                                value={criminalProceedings === "no" ? "no" : "yes"}
                                onChange={(e) =>
                                    e.target.value === "no"
                                        ? setCriminalProceedings("no")
                                        : setCriminalProceedings("")
                                }
                                className="w-[45%] flex md:justify-end"
                            >
                                <div className="flex">
                                    <FormControlLabel
                                        sx={{
                                            "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                                            {
                                                color: "#E42125",
                                            },
                                            "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                                                color: "#E42125",
                                            },
                                        }}
                                        value="yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        sx={{
                                            "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                                            {
                                                color: "#E42125",
                                            },
                                            "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                                                color: "#E42125",
                                            },
                                        }}
                                        value="no"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </div>

                            </RadioGroup>
                            {/* <RadioGroup
                            row
                            name="key_metrics1"
                            value={criminalProceedings ? "yes" : "no"}
                            onChange={(e) =>
                              setCriminalProceedings(e.target.value === "yes")
                            }
                            className="w-[45%]"
                          >
                           
                          </RadioGroup> */}
                        </div>
                        {criminalProceedings !== "no" && (

                            <TextInput
                                placeholder="Enter Details"
                                value={criminalProceedings}
                                onChange={(e) => setCriminalProceedings(e.target.value)}
                            />
                        )}
                    </div>
                </div>

                <div className="w-full mt-2">
                    <div className=" mb-5">
                        <div className="flex flex-col md:flex-row md:items-center justify-between md:gap-2">
                            <p className="text-sm font-medium text-gray-900 md:mb-1  w-[100%]">
                                Are you High Networth Individual? (HNI means Individuals with Investable Assets Exceeding INR 5 crore.) :
                                {/* <span className="text-red-600">*</span> */}
                            </p>
                            <RadioGroup
                                row
                                name="key_metrics1"
                                value={isHighNetworthIndividual ? "yes" : "no"}
                                onChange={(e) =>
                                    setIsHighNetworthIndividual(e.target.value === "yes")
                                }
                                className="w-[45%] flex md:justify-end"
                            >
                                <div className="flex ">

                                    <FormControlLabel
                                        sx={{
                                            "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                                            {
                                                color: "#E42125",
                                            },
                                            "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                                                color: "#E42125",
                                            },
                                        }}
                                        value="yes"
                                        control={<Radio />}
                                        label="Yes"
                                    />
                                    <FormControlLabel
                                        sx={{
                                            "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                                            {
                                                color: "#E42125",
                                            },
                                            "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                                                color: "#E42125",
                                            },
                                        }}
                                        value="no"
                                        control={<Radio />}
                                        label="No"
                                    />
                                </div>
                            </RadioGroup>
                        </div>
                    </div>
                </div>


                <div className="flex flex-col gap-4 mt-4">
                    <TextInput
                        // AsteriskStar={true}
                        label="Obtaining more information from the consumer regarding the purpose and nature of the business connection"
                        placeholder="Enter details"
                        id="natureofbusiness"
                        value={purposeNatureBusinessConnection}
                        onChange={(e) => setPurposeNatureBusinessConnection(e.target.value)}
                        height="35px"
                    />
                    <TextInput
                        // AsteriskStar={true}
                        label="Gathering information from publicly available sources or otherwise"
                        placeholder="Enter details"
                        id="publiclyavailableinformation"
                        value={publicInfo}
                        onChange={(e) => setPublicInfo(e.target.value)}
                        height="35px"

                    />
                </div>

                {!isRecordExist && <>
                    <div className="mt-6 md:mt-4">
                        <CommonDropDown
                            options={options.option4}
                            selected={political}
                            setSelected={setPolitical}
                            label={"Are you a Politically Exposed Person(PEP) or family member/ close relative / associate of PEP"}
                            labelSize="small"
                            height="35px"
                            AsteriskStar={true}
                            disabled={CDDData.political || false}

                        />
                        {/* <p className="text-red-500 text-sm" id="incomeError">
                                          {error && error}
                                        </p> */}
                        <i className="text-[10px] font-medium text-gray-600">
                            "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions by a foreign country, including the heads of States or Governments, senior politicians, senior government or judicial or military officers, senior executives of state-owned corporations and important political party officials.
                        </i>

                    </div>
                </>}

                {/* <div className="mt-6 md:mt-4">

                    <div className="flex flex-col">

                        <div className="flex flex-col md:flex-row md:items-center justify-between md:gap-2">

                            <p className="text-[10px] font-medium text-gray-900 md:mb-1 md:w-[50%]">

                                Are you a Politically Exposed Person (PEP) or Family Member/ Close Relative / Associate of PEP

                                <span className="text-red-600">*</span>

                            </p>



                            <RadioGroup

                                row

                                name="political"

                                value={political}

                                onChange={(e) => setPolitical(e.target.value)}

                                className=""

                            >

                                {options.option4.map((opt, idx) => (

                                    <FormControlLabel

                                        key={idx}

                                        value={opt}

                                        control={<Radio />}

                                        label={opt}

                                    />

                                ))}

                            </RadioGroup>

                        </div>



                        <i className="text-xs font-medium text-black md:mt-2">

                            "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions

                            by a foreign country, including the heads of States or Governments, senior politicians, senior government or

                            judicial or military officers, senior executives of state-owned corporations and important political party offici

                            als.

                <div className="mt-4">
                        <CommonDropDown
                            options={options.option4}
                            selected={political}
                            setSelected={setPolitical}
                            label={"Are you a Politically Exposed Person(PEP) or family member/ close relative / associate of PEP"}
                            AsteriskStar={true}
                        />
                       
                        <i className="text-xs font-medium text-black">
                            "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions by a foreign country, including the heads of States or Governments, senior politicians, senior government or judicial or military officers, senior executives of state-owned corporations and important political party officials.
                        </i>

                    </div>

                </div> */}
            </>
            <p className="text-red-500 text-sm mt-2" id="incomeError">
                {error && error}
            </p>

            <div className="w-full mt-4 md:w-[15%] mb-3 flex justify-center">
                <CommonButton
                    center
                    label="Submit"
                    filled
                    onClickHandler={onClickHandler}
                />
            </div>
            {idvModal &&
                <CommonTemplate4
                    isTemplateOpen={idvModal}
                    okTemplate={eddHandler}
                    submitTemplate={eddHandler}
                    closeTemplate={closeEddHandler}
                    modalLabel={"Please Note"}
                >
                    <p className="md:text-center text-sm">
                        {`As per IRDAI norms, filling of EDD questionnaire against your KYC with the name `}
                        &nbsp;
                        <span className="capitalize">{kycName}</span>
                        {` is mandatory. Please click on proceed button to continue.`}

                    </p>
                </CommonTemplate4>
            }
        </div>

    );
};

export default Individual;